module.exports = __webpack_public_path__ + "img/main-logo.622fe9dc.png";